import {
  LOAD_AUDIENCE_ANNOTATIONS,
  UNLOAD_CURRENT_ARTIST,
} from '../../actionTypes';
import { loadReducer } from '../helpers';

export const annotations = (state = null, action) => {
  switch (action.type) {
    case UNLOAD_CURRENT_ARTIST:
      return null;
    case LOAD_AUDIENCE_ANNOTATIONS:
      return loadReducer(state, action);
    default:
      return state;
  }
};
